export const GET_TOTAL_STATS_INCIDENT = 'EHELP/get_total_stats';
export const GET_GRAPH_STATS = 'EHELP/get_graph_stats';

export const GET_TOTAL_STATS_COVID_VACCINE =
  'CDL/get_total_stats_covid_vaccine';

export const LEGENDS = [
  { name: 'INCIDENT REPORT', color: '#A3B3F9', value: 0 },
];

export const COVID_19_LEGENDS = [
  { name: 'COVID-19 VACCINE', color: '#A3B3F9', value: 0 },
];

export const GET_VACCINE_REGISTRATION_GRAPH = 'EHELP/get_vaccination_registration_graph'
